<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { reactive, computed } from "vue";
import { Link, usePage, useForm } from "@inertiajs/inertia-vue3";
import { BellIcon, UserIcon, MenuIcon, XIcon, SearchIcon } from '@heroicons/vue/outline'
import Search from "./Search";
import Breadcrumbs from "./Breadcrumbs";
import ShoppingCartButton from "./ShoppingCart/ShoppingCartButton";

const themeColor = computed(() => usePage().props.value.theme_color)
const themeLogo = computed(() => usePage().props.value.theme_logo)
const customer = computed(() => usePage().props.value.auth.customer)
const breadcrumbs = computed(() => usePage().props.value.breadcrumbs)

const user = computed(() => {
  return usePage().props.value.auth.user;
})

const userNavigation = [
  { name: 'Profiel', href: route('profile.show'), method: 'get' },
  { name: 'Bestellingen', href: route('orders.index'), method: 'get' },
  { name: 'Uitloggen', href: route('logout'), method: 'post' },
]

const employeeNavigation = [
  { name: 'Uitloggen', href: route('logout'), method: 'post' },
]

function navigation() {
  if(user.value.role === 'customer') {
    return userNavigation
  }

  return employeeNavigation;
}
</script>

<template>
    <Disclosure as="nav"  :style="{'background-color': themeColor}" :class="{ 'bg-gradient-to-r from-orange-400 to-orange-600': !themeColor }" v-slot="{ open }">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">

          <div class="md:flex flex-1 items-center justify-between py-4 md:py-0 md:h-16 space-y-4 md:space-y-0">
                <div class="flex flex-col md:flex-row items-center">
                    <div class="flex-shrink-0">
                      <Link :href="route('storefront')" class="">
                        <img class="max-h-12" :src="themeLogo" alt="logo" /></Link>
                    </div>
                    <div class="hidden lg:block">
                        <div class="ml-10 flex items-baseline space-x-4">
                            <Link v-for="item in navigation"
                                  :key="item.name"
                                  :href="item.href"
                                  :class="[$page.url === item.href ? 'font-bold text-white' : 'text-white hover:text-gray-300 font-medium', 'px-3 py-2 rounded-md text-sm ']" :aria-current="$page.url === item.href ? 'page' : undefined"
                            >
                                {{ item.name }}
                            </Link>
                        </div>
                    </div>
                </div>

               <!-- Wrap search on profile on mobile devices -->
                <div class="flex flex-row w-full">
                  <div class="flex justify-center px-2 w-full">
                    <Search class="w-full max-w-full md:max-w-md w-auto md:w-full xl:max-w-lg"/>
                  </div>

                  <div class="flex-shrink-0 flex items-center justify-end">
                    <div class="flex items-center lg:ml-8">
                      <div class="flex space-x-8">
                        <!-- Profile dropdown -->
                        <Menu v-if="customer" as="div" class="relative p-1">
                          <div>
                            <MenuButton class="max-w-xs rounded-full flex hover:text-gray-300 items-center text-sm text-white focus:outline-none  focus:ring-white">
                              <span class="sr-only">Open user menu</span>
                              <UserIcon class="h-6 w-6" aria-hidden="true" />
                            </MenuButton>
                          </div>
                          <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                            <MenuItems class="z-10 origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                              <MenuItem v-for="item in navigation()" :key="item.name" v-slot="{ active }">
                                <Link :href="item.href" :method="item.method" as="button" :class="[active ? 'bg-gray-100' : '', 'flex w-full px-4 py-2 text-sm text-gray-700']">{{ item.name }}</Link>
                              </MenuItem>
                            </MenuItems>
                          </transition>
                        </Menu>

                        <!-- Login Popover -->
                        <Link v-if="!customer" :href="route('login.form')" class="max-w-xs rounded-full flex hover:text-gray-300 items-center text-sm text-white focus:outline-none  focus:ring-white">
                          <span class="sr-only">Open user menu</span>
                          <UserIcon class="h-6 w-6" aria-hidden="true" />
                        </Link>
                      </div>

                      <span class="mx-4 h-6 w-px bg-gray-200 lg:mx-6" aria-hidden="true" />

                      <div class="flow-root">
                        <ShoppingCartButton />
                      </div>
                    </div>
                  </div>
                </div>

            </div>
        </div>
    </Disclosure>

    <Breadcrumbs :pages="breadcrumbs"/>
</template>
